import httpUtils from '../utils/http-utils';

const SERVICE_NAME = process.env.REACT_APP_API_ENDPOINT+"/documentGallery";
const SERVICE_UPLOAD_NAME = process.env.REACT_APP_API_ENDPOINT;

const generateLinkDocumentGalleryById = (payload) => {
    return httpUtils.post(SERVICE_NAME + "/generateLinkDocumentGalleryById", payload);
}

const moveFile = (payload) => {
    return httpUtils.post(SERVICE_NAME + "/moveFile", payload);
}

const createFolder = (payload) => {
    return httpUtils.post(SERVICE_NAME + "/createFolder", payload);
}

const edit = (payload) => {
    return httpUtils.postFormData(SERVICE_NAME + "/edit", payload);
}

const remove = (payload) => {
    return httpUtils.post(SERVICE_NAME + "/delete", payload);
}

const search = (condition = {}, paginable = { rowPerPage: 999, currentPage: 1 }) => {
    return httpUtils.post(SERVICE_NAME + "/search", {condition, paginable});
}

const add = (formData) => {
    return httpUtils.postFormData(SERVICE_UPLOAD_NAME + "/upload/documentGallery", formData);
}

const documentGalleryApi = {
    generateLinkDocumentGalleryById,
    moveFile,
    createFolder,
    edit,
    remove,
    search,
    add
}

export default documentGalleryApi;